<ng-template cdk-portal="">
  <ng-content></ng-content>
</ng-template>